module.exports = __webpack_public_path__ + "img/图片10.0cc84ad2.png";